import { ApiClient } from '@webapp/core/services/ApiClient'
import { SecondaryCategoryRepository } from './SecondaryCategoryRepository'

export const secondaryCategoryRepository = new SecondaryCategoryRepository({
  httpClient: ApiClient,
})
